import { FormPanel } from '@dreryk/react-components';

import { MyAccountActionBar } from '../actionBar/MyAccountActionBar';

import { CertificateForm } from './CertificateForm';

type CertificatePanelProps = {
   readonly onCertificateSave: VoidFunction;
};
const CertificatePanel = (props: CertificatePanelProps): JSX.Element => {
   return (
      <MyAccountActionBar>
         <FormPanel>
            <CertificateForm onCertificateSave={props.onCertificateSave} />
         </FormPanel>
      </MyAccountActionBar>
   );
};

export { CertificatePanel };
